import React, { useState } from 'react';
import UserManagementTable from './UserManagementTable';
import TierFeatureMatrix from './TierFeatureMatrix';
import TierLimitsMatrix from './TierLimitsMatrix';

function RolesManagement() {
  const [activeSection, setActiveSection] = useState('users');

  return (
    <div className="roles-management">
      <div className="roles-intro">
        <h2>User Roles & Feature Access</h2>
        <p>
          Manage user subscription tiers, configure feature access, and set usage limits for each tier.
          Admin users (is_staff=True) automatically have access to all features and bypass all limits.
        </p>
        <p>
          <strong>App Access</strong> (Feature Matrix) decides who can open the app at all: a tier set to
          No sees only the offline notice. Admins always have full access. The App access column in
          User Management shows the result for each person.
        </p>
      </div>

      <div className="roles-section-tabs">
        <button
          className={`section-tab ${activeSection === 'users' ? 'active' : ''}`}
          onClick={() => setActiveSection('users')}
        >
          User Management
        </button>
        <button
          className={`section-tab ${activeSection === 'matrix' ? 'active' : ''}`}
          onClick={() => setActiveSection('matrix')}
        >
          Feature Matrix
        </button>
        <button
          className={`section-tab ${activeSection === 'limits' ? 'active' : ''}`}
          onClick={() => setActiveSection('limits')}
        >
          Tier Limits
        </button>
      </div>

      <div className="roles-content">
        {activeSection === 'users' && <UserManagementTable />}
        {activeSection === 'matrix' && <TierFeatureMatrix />}
        {activeSection === 'limits' && <TierLimitsMatrix />}
      </div>
    </div>
  );
}

export default RolesManagement;
